import { pageHeaderStyles } from 'app/components/presentation/text/styles';
import { useClasses } from 'app/utils/css';
import React, { Fragment, ReactNode } from 'react';

const PageHeader = ({
  children,
  header,
}: {
  children?: ReactNode,
  header?: ReactNode,
}) => {
  const hasChildren = !!children;

  const classes = useClasses({
    header: {
      margin: hasChildren ? '0 0 25px 0' : '0',
      padding: '0 5px',
      textAlign: 'center',
    },
    headerText: pageHeaderStyles,
  });

  return (
    <Fragment>
      {header &&
        <header className={classes.header}>
          <h1 className={classes.headerText}>{header}</h1>
        </header>}

      {children}
    </Fragment>
  );
};

export default PageHeader;
